"use client";

import type { FC } from "react";

import { isEditing } from "@builder.io/sdk-react";

import { SearchResults as SearchResultsUI } from "@jti/ui/components/Search";

import { useLocale } from "@/context/LocaleContext";

import { Placeholder } from "../Placeholder/Placeholder";

import type { searchResultsInputs } from "./SearchResults.builder";
import { DEFAULT_INITIAL_RESULTS_NUMBER, DEFAULT_LOAD_RESULTS_PER_PAGE } from "./SearchResults.builder";

export type SearchResultsProps = BuilderComponentProps<typeof searchResultsInputs>;

const SEARCH_TYPE_MAP = {
  faq: "faq",
  page: "page",
  product: "product",
  all: "",
} as const;

export const SearchResults: FC<SearchResultsProps> = ({
  loadResultsPerPage,
  searchType,
  translations,
  initialResultsNumber,
}) => {
  const { currentLang } = useLocale();
  const lang = currentLang.substring(0, 2);
  if (isEditing()) {
    return (
      <Placeholder>
        Placeholder. Component will display proper results only on preview with proper query search param.
      </Placeholder>
    );
  }
  return (
    <SearchResultsUI
      loadResultsPerPage={loadResultsPerPage ?? DEFAULT_LOAD_RESULTS_PER_PAGE}
      searchType={SEARCH_TYPE_MAP[searchType] || ""}
      translations={translations}
      locale={lang}
      initialResultsNumber={initialResultsNumber ?? DEFAULT_INITIAL_RESULTS_NUMBER}
    />
  );
};
